var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useThemeUI, css } from 'theme-ui';
import { get, map } from 'lodash';
export function useThemeStyle() {
    var styles = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        styles[_i] = arguments[_i];
    }
    var theme = useThemeUI().theme;
    return getThemeStyle.apply(void 0, styles)(theme);
}
export function getThemeStyle() {
    var styles = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        styles[_i] = arguments[_i];
    }
    return function (theme) {
        return styles
            .filter(function (x) { return x != null; })
            .map(function (style) { return (typeof style === 'string' ? get(theme, style) : style); })
            .map(function (style) { return css(style)(theme); });
    };
}
export function getThemeKeyNames(themeProps, themeKey) {
    var names = map(themeProps, function (variant, name) {
        return (themeKey ? "".concat(themeKey, ".").concat(name, ".") : 'styles.') + variant;
    });
    return themeKey ? __spreadArray(["".concat(themeKey, ".base")], names, true) : names;
}
//# sourceMappingURL=useThemeStyle.js.map